<template>
	<div>
		<div :class="['row', {'py-5' : extraSpace !== false }, 'justify-content-center']">
			<div class="col-md-6 col-md-offset-1 z-1 pl-5 py-3">
				<div class="panel panel-default px-5 py-2 bg-white">
					<p v-if="extraSpace" class="text-center m-b-0-i m-t-25"><i class="fas fa-hand-o-up fa-2x" aria-hidden="true"></i></p>
					<h3 :class="['text-center',  extraSpace && 'm-y-40']" style="font-size:1.325em;">Pick Your Occupations</h3>
					<pli-select
						@select="selectOccupation"
						v-model="selected"
						:options="options"
						:multiple="false"
						track-by="id"
						placeholder="Type to search and select"
						label="business_activity"
					/>
					<p class="text-center m-b-25 m-t-20">
						<span class="text-red m-b-20" v-if="feedback" v-text="feedback"></span>
						<button type="button" class="btn btn-fill btn-blue btn-wd m-t-15 p-x-45-i" @click.prevent="confirm">Continue to Quote <i class="fas fa-arrow-right"></i></button>
					</p>
				</div>
			</div>

			<div class="col-md-4 p-3" style="z-index: 0;">
				<div class="panel panel-default p-l-15 p-r-15 cant-find-occupation-box text-center py-2" style="background:#f0f0f0;">
					<p class="text-center m-b-0-i"><i class="fa fa-question-circle-o fa-2x" aria-hidden="true"></i></p>
					<h3 class="text-center m-t-40 m-b-0-i" style="font-size:1.325em;">Can't Find Your Occupation?</h3>
					<img :src="imagePath" id="thinking-guy-img" alt="" class="img-responsive text-center">
					<p class="text-center m-b-25 m-t-20">
						<a
							class="btn btn-default-faded btn-wd"
							href="https://www.publicliabilityinsurance.com.au/public-liability-insurance-quote/"
							rel="noopener noreferrer">
							<i class="fas fa-info"></i> Get a Custom Quote
						</a>
					</p>
				</div>
			</div>
		</div>

		<!--
		<div class="row">
			<div class="col-md-10 col-md-offset-1 text-center m-t-20">
				<img :src="bannerPath" id="thailand-banner-img" alt="" class="img-responsive" />
				<p class="banner-tc category m-t-10">*Conditions Apply.Please refer to full <a class="banner-tc-link" target="_blank" :href="bannerUrl">terms &amp; conditions</a>.</p>
			</div>
		</div>
		-->
	</div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import { isEmpty, find } from 'lodash'
import { apiDomain } from '../configs'
import { bannerUrl } from '../configs'
import PliSelect from './form/PliSelect'

export default {
	props: {
		pendingOrder: {},
		extraSpace: {
			type: Boolean,
			default: true,
		}
	},

	components: { PliSelect },

	data() {
		return {
			selected: null,
			options: [],
			feedback: '',
		}
	},

	computed: {
		...mapState({
			configs: state => state.configs,
			error: state => state.error,
		}),

		imagePath () {
			return `${apiDomain}images/thinking-guy.png`
		},

		bannerPath () {
			return `${apiDomain}images/thailand-banner.jpg`
		},

		bannerUrl(){
			return `${bannerUrl}`
		},
	},

	watch: {
		configs({ occupations }) {
			this.options = occupations
		},
	},

	methods: {
		...mapMutations({
			updateSelectedOccupation: 'updateSelectedOccupation'
		}),
		selectOccupation (value) {
			this.feedback = ''
			this.$emit('updateOccupation', value)
		},

		confirm () {
			if (isEmpty(this.selected)) {
				this.feedback = 'Please select your occupation'
				return
			}
			this.feedback = ''
			this.updateSelectedOccupation({ selectedOccupation: true })
			this.$emit('confirmOccupation')
		},

		resetOccupation () {
			this.selected = null
		}
	},

	mounted() {
		if(!isEmpty(this.configs)) {
			this.options = this.configs.occupations
		}
	}
}
</script>

<style lang="scss">
.wizard-header.quote-rejected-header {
	z-index: -1;
}
.cant-find-occupation-box {
	// height: 179px;

	@media screen and (max-width: 991px) {
		height: auto;
	}
}
.wizard-card .tab-content {
	padding: 10px;
}
.z-1 {
	z-index: 1;
}
.z-0 {
	z-index: 0;
}
.m-t-80 {
	margin-top: 80px;
}
.btn-blue {
	background-color:#32a8ff !important;
	border-color:#32a8ff !important;

	&::hover {
		background-color: darken(#32a8ff, 20) !important;
		border-color: darken(#32a8ff, 20) !important;
	}
}
.btn-default-faded {
	background: none !important;
	border-color:#8f877d !important;
	color: #8f877d !important;

	&::hover {
		color: #8f877d !important;
		background: none !important;
		border-color: darken(#8f877d, 20) !important;
	}
}
#thinking-guy-img {
	height: 100px;
    margin: 22px auto;
}

#thailand-banner-img {
	height: 90px;
    margin: 0px auto;
}
.text-red {
	color: red;
}
.banner-tc{
  font-size: 12px !important;
}
</style>
